/**
 * @file: description
 * @author: dongjing
 * @Date: 2020-01-03 13:20:42
 * @LastEditors: dongjing
 * @LastEditTime: 2020-02-10 11:40:09
 */
import './imgAlign.less';

export interface IResizer {
  onUpdate: () => void;
  img: HTMLImageElement;
  overlay: HTMLElement;
  options: {};
}

class ImgAlign {
  public overlay: HTMLElement;

  public img: HTMLImageElement;

  public toolbar: HTMLElement;

  public alignments: {
    apply: () => void;
    name: string;
  }[];

  public options: {};

  public requestUpdate: () => void;

  public constructor(resizer: IResizer) {
    this.overlay = resizer.overlay;
    this.img = resizer.img;
    this.options = resizer.options;
    this.requestUpdate = resizer.onUpdate;
  }

  private defineAlignments = () => {
    this.alignments = [
      {
        apply: () => {
          this.img.align = 'left';
        },
        name: 'left'
      },
      {
        apply: () => {
          this.img.align = 'center';
        },
        name: 'center'
      },
      {
        apply: () => {
          this.img.align = 'right';
        },
        name: 'right'
      }
    ];
  };

  private addToolbarButtons = () => {
    const toolbar = document.createElement('div');

    toolbar.className = 'ql__img-tool-bar';

    this.alignments.forEach(item => {
      const btn = document.createElement('div');

      btn.className = `img__btn img__btn--${item.name}`;
      btn.setAttribute('data-type', item.name);
      toolbar.append(btn);
    });

    toolbar.addEventListener('click', this.handleToolbarClick);

    this.toolbar = toolbar;
    this.overlay.append(toolbar);
  };

  public handleToolbarClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    const type = target.getAttribute('data-type');

    if (type) {
      this.img.align = type;
      this.requestUpdate();
    }
  };

  public onCreate = () => {
    this.defineAlignments();
    this.addToolbarButtons();
  };

  public onDestroy = () => {
    this.toolbar.removeEventListener('click', this.handleToolbarClick);
  };

  public onUpdate = () => {
    // onUpdate
  };
}

export default ImgAlign;
